import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { RefObject } from "react";

import tagCore from "../../core/tag.core";
import Dialog from "../form/dialog.comp";

interface DeleteTagDialogProps {
  dialogRef: RefObject<HTMLDialogElement>;
  tagId: string;
  clickCancelled?: VoidFunction;
}

export default function DeleteTagDialog({ dialogRef, tagId, clickCancelled }: DeleteTagDialogProps) {
  const queryClient = useQueryClient();
  const { isReady } = useRouter();

  async function clickConfirmed() {
    const data = (await tagCore.deleteTag(tagId)) as { message: string };

    if (data.message === "success") {
      queryClient.invalidateQueries({ queryKey: ["tags"] });
      queryClient.invalidateQueries({ queryKey: ["tags"] });
    }
  }

  if (!isReady) return null;

  return (
    <>
      <Dialog
        title="Delete Tag"
        message={`Are You sure to delete this tag?`}
        dialogRef={dialogRef}
        confirm={clickConfirmed}
        cancel={clickCancelled}
      />
    </>
  );
}
